import { CharField, ImageField, NumberField, SwitchField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { AtlanteFormType } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

export default function AtlanteForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<AtlanteFormType>()
  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.nome}
        onChange={(value) => {
          setFieldValue("nome", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "nome") : undefined}
        errorMessage={getIn(errors, "nome")}
        required
      />
      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        value={values.descrizione || ""}
        onChange={(value) => {
          setFieldValue("descrizione", value)
        }}
      />
      <ImageField
        label="Immagine"
        layout="horizontal"
        value={values.immagine_copertina}
        onChange={(value) => {
          setFieldValue("immagine_copertina", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "immagine_copertina") : undefined}
        errorMessage={getIn(errors, "immagine_copertina")}
        required
      />
      <SwitchField
        label="Bozza"
        layout="horizontal"
        value={values.bozza}
        onChange={(value) => {
          setFieldValue("bozza", value)
        }}
      />
      <WysiwygField
        label="Informazioni Atlante"
        layout="horizontal"
        value={values.informazioni_atlante || ""}
        onChange={(value) => {
          setFieldValue("informazioni_atlante", value)
        }}
      />
    </Col>
  )
}
